import EnforcementStatusEnum from 'redpoints-model-js/enumeration/EnforcementStatusEnum';
import LinkTypeEnum from 'redpoints-model-js/enumeration/LinkTypeEnum';
import LinkSetStatusObject from 'redpoints-model-js/model/system/LinkSetStatusObject';

import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';
import DomainsForShortenerLinkController from 'redpoints-restapi-connector/controller/DomainsForShortenerLinkController';
import LinkController from 'redpoints-restapi-connector/controller/LinkController';
import ShortenerLinkController from 'redpoints-restapi-connector/controller/ShortenerLinkController';

import {
  CONNECTOR_REQUEST,
  SHORTENER_RESOLUTION_CLEAR,
  SHORTENER_RESOLUTION_CLEAR_LINK_TO_RESOLVE,
  SHORTENER_RESOLUTION_CLOSE_LINK,
  SHORTENER_RESOLUTION_DELAY_LINK,
  SHORTENER_RESOLUTION_FETCH_DOMAINS,
  SHORTENER_RESOLUTION_FETCH_LINK_TO_RESOLVE,
  SHORTENER_RESOLUTION_RESOLVE_LINK,
  SHORTENER_RESOLUTION_SET_FILTERS_SELECTED,
  SHORTENER_RESOLUTION_SET_TARGET_LINKS,
} from './actionTypes';
import { translate } from '../helpers/languageHelper';

const getErrorMessage = (key = 'default') =>
  translate(`tasks.shortenerResolution.messages.errors.${key}`);

const successMessage = translate('tasks.shortenerResolution.messages.success');

export const shortenerResolutionClear = () => ({
  type: SHORTENER_RESOLUTION_CLEAR,
});

export const shortenerResolutionClearLinkToResolve = () => ({
  type: SHORTENER_RESOLUTION_CLEAR_LINK_TO_RESOLVE,
});

export const shortenerResolutionFetchDomains = ({ domainUrl, customerId }) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: SHORTENER_RESOLUTION_FETCH_DOMAINS,
    connectorMethod: DomainsForShortenerLinkController.list,
    sortedParameters: [domainUrl, customerId],
    expectedStatus: HttpStatus.OK,
    errorMessage: getErrorMessage(),
  },
});

export const shortenerResolutionSetFiltersSelected = ({
  domain,
  filterByCustomer,
}) => ({
  type: SHORTENER_RESOLUTION_SET_FILTERS_SELECTED,
  payload: {
    domain,
    filterByCustomer,
  },
});

export const shortenerResolutionFetchLinkToResolve = ({
  domainIds,
  customerId,
}) => {
  const full = false;
  return {
    type: CONNECTOR_REQUEST,
    meta: {
      requestType: SHORTENER_RESOLUTION_FETCH_LINK_TO_RESOLVE,
      connectorMethod: ShortenerLinkController.getNextLink,
      sortedParameters: [full, domainIds, customerId],
      expectedStatus: HttpStatus.OK,
      mustShowErrorMessages: false,
    },
  };
};

export const shortenerResolutionDelayLink = ({ context, linkId }) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    context,
    requestType: SHORTENER_RESOLUTION_DELAY_LINK,
    connectorMethod: ShortenerLinkController.delayLink,
    sortedParameters: [linkId],
    expectedStatus: HttpStatus.NO_CONTENT,
    successfulMessage: successMessage,
    errorMessage: getErrorMessage('link'),
  },
});

export const shortenerResolutionResolveLink = ({
  context,
  linkId,
  urlToResolve,
}) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    context,
    requestType: SHORTENER_RESOLUTION_RESOLVE_LINK,
    connectorMethod: ShortenerLinkController.resolveLinkById,
    sortedParameters: [linkId, urlToResolve],
    expectedStatus: HttpStatus.NO_CONTENT,
    successfulMessage: successMessage,
    errorMessage: getErrorMessage('link'),
  },
});

export const shortenerResolutionCloseLink = ({ context, linkId, link }) => {
  const linkSetStatusObject = new LinkSetStatusObject();
  linkSetStatusObject.enforcementStatus = EnforcementStatusEnum.CLOSED;
  linkSetStatusObject.linkType = LinkTypeEnum.SHORTENER;
  linkSetStatusObject.url = link.url;
  return {
    type: CONNECTOR_REQUEST,
    meta: {
      context,
      requestType: SHORTENER_RESOLUTION_CLOSE_LINK,
      connectorMethod: LinkController.status,
      sortedParameters: [linkId, linkSetStatusObject],
      expectedStatus: HttpStatus.NO_CONTENT,
      successfulMessage: successMessage,
      errorMessage: getErrorMessage('link'),
    },
  };
};

export const shortenerResolutionSetTargetLinks = ({ targetLink }) => ({
  type: SHORTENER_RESOLUTION_SET_TARGET_LINKS,
  payload: { targetLink },
});
